module.exports = "/assets/dist/img/satisfaction-guarantee-badge.png?cfba1e09cc0cc12406c285ede73aeec9";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/pictureday/site-footer/assets/satisfaction-guarantee-badge.png
// module id = 2114
// module chunks = 29